import {AirQualityColorsEnum} from '@/enums/AirQualityColorsEnum';
import airQualityRanges from '@/assets/json/airQualityRanges.json';

export default class AirQualityService {

  public static getColor(paramName: string, paramValue: number): string {
    const singleParamQualityRanges = airQualityRanges[paramName as keyof typeof airQualityRanges];

    const selectedQualityObject = Object.entries(singleParamQualityRanges).find((item: any) => {
      const {from, to} = item[1];

      if (to === null) {
        if (paramValue >= from) {
          return item;
        } 
      } else if (paramValue >= from && paramValue <= to) {
          return item;  
      }

      return null;
    });

    const selectedQualityName = selectedQualityObject?.[0];

    if (selectedQualityName) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return AirQualityColorsEnum[selectedQualityName];
    } 
    
    return AirQualityColorsEnum.EMPTY_INDEX;
  }
}
